import * as React from "react";
const SvgPlay32Fill = props => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}><path d="M8 6.71c0-2.171 2.505-3.457 4.357-2.239l13.42 8.826a2.657 2.657 0 0 1 .107 4.402l-13.42 9.755C10.626 28.791 8 27.52 8 25.29z" /></svg>;
export default SvgPlay32Fill;